<template>
    <div>
        <el-card :body-style="{ padding: '0px' }" shadow="hover">
          <!-- <el-popover placement="top" trigger="hover"> -->
            <img src="../assets/images/cover.png" class="image" style="width: 808px;height: 470px">
            <!-- <img slot="reference" src="../assets/images/cover.png" class="image"> -->
          <!-- </el-popover> -->
        </el-card>
        <el-row gutter="8">
          <el-col :span="8" v-for="itemSpec in spec" :key="itemSpec.id">
            <el-card class="spec-card" :body-style="{ padding: '0px' }" shadow="hover">
              <div slot="header">
                <i class="el-icon-s-platform" :style='itemSpec.color'></i>
                {{itemSpec.name}}
              </div>
              <div>
                <p><i class="el-icon-caret-right"></i>{{itemSpec.OS}}</p>
                <p><i class="el-icon-caret-right"></i>{{itemSpec.Bit}}</p>
                <i class="el-icon-caret-right"></i><el-tag effect="dark">{{itemSpec.price}}</el-tag>
                <p><i class="el-icon-caret-right"></i>{{itemSpec.feature}}</p>
              </div>
            </el-card>
          </el-col>
    </el-row>
    <el-row>
      <el-card class="memo" :shadow="false">
        <i class="el-icon-caret-right"></i>
        Windows XPの場合、<a href="https://www.microsoft.com/en-us/download/details.aspx?id=26368">Microsoft VC++ 2008 SP1 再頒布可能パッケージ</a>をインストールする必要です.<br>
        <i class="el-icon-caret-right"></i>
        {{shareware}}
      </el-card>
    </el-row>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      shareware: 'シェアウェアです、30日間、全機能の試用が可能です',
      spec: [
        {
          id: '1',
          name: 'Std版',
          color: 'color:blue',
          OS: 'Windows XP、Windows 7, Windows Vista, Windows Server 2003/2008, Windows 8, Windows 10, Windows 11',
          Bit: '32Bit / 64Bit',
          price: '3410円（税込み）',
          feature: '32Bit・64Bit両方ともサポート、32Bit　OSのため、１GB以下のメモリ利用制限があります'
        }, {
          id: '2',
          name: 'Pro版',
          color: 'color:#00ff00',
          OS: 'Windows 7, Windows Server 2003/2008, Windows 8, Windows 10, Windows 11',
          Bit: '64Bit',
          price: '5602円（税込み）',
          feature: '64Bitに特化した、メモリの利用制限がない、従来のWindowsUI版とWebUI版両方も用意しています'
        },
        {
          id: '3',
          name: 'Mac OS版',
          color: 'color:Violet',
          OS: 'Mac OS',
          Bit: '64Bit',
          price: '5602円（税込み）',
          feature: 'Pro版と同じ機能で、使用前にセキュリティとプライバシーで実行の許可をください'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .spec-card {
      margin-top: 20px;
       height: 400px;
       overflow:auto;
   }
   .memo {
      margin-top: 2px;
      font-size: 16px;
   }
</style>
